import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Container, Typography, TextField, Button, Box, Snackbar, Alert } from '@mui/material';
import { useParams } from 'react-router-dom';
import MediaUploadField from '../MediaUploadField';

const modules = {
    toolbar: [
        [{ 'font': [] }],
        [{ 'header': '1' }, { 'header': '2' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link', 'image', 'blockquote', 'code-block'],
        ['clean'],
    ],
};

const EditarArtigo = () => {
    const { id } = useParams();
    const apiUrl = process.env.REACT_APP_API_URL;

    const [formData, setFormData] = useState({
        titulo: '',
        subtitulo: '',
        imagem: '',
        pdfLink: '',
        conteudo: '',
    });

    const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        const loadArtigo = async () => {
            try {
                const response = await axios.get(`${apiUrl}/artigos/${id}`);
                const artigo = response.data;
    
                setFormData({
                    titulo: artigo.titulo || '',
                    subtitulo: artigo.subtitulo || '',
                    imagem: artigo.imagens?.length > 0 ? artigo.imagens[0] : '', // Pegando a primeira imagem do array
                    pdfLink: artigo.arquivoDownload || '',
                    conteudo: artigo.conteudo || '',
                });
    
            } catch (error) {
                console.error(error);
                setAlertMessage({ type: 'error', text: 'Erro ao carregar artigo para edição.' });
                setOpenSnackbar(true);
            }
        };
        loadArtigo();
    }, [apiUrl, id]);
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const setFieldValue = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleUploadError = (message) => {
        setAlertMessage({ type: 'error', text: message });
        setOpenSnackbar(true);
    };
    const handleUploadSuccess = (message) => {
        setAlertMessage({ type: 'success', text: message });
        setOpenSnackbar(true);
    };

    const handleConteudoChange = (value) => {
        setFormData((prev) => ({
            ...prev,
            conteudo: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('token');
        if (!token) {
            setAlertMessage({ type: 'error', text: 'Você precisa estar autenticado para editar o artigo.' });
            setOpenSnackbar(true);
            return;
        }

        try {
            await axios.put(`${apiUrl}/artigos/${id}`, formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setAlertMessage({ type: 'success', text: 'Artigo atualizado com sucesso!' });
            setOpenSnackbar(true);
        } catch (error) {
            console.error('Erro ao atualizar artigo:', error);
            setAlertMessage({ type: 'error', text: 'Erro ao atualizar artigo. Tente novamente.' });
            setOpenSnackbar(true);
        }
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h2" align="center" gutterBottom>
                Editar Artigo
            </Typography>

            <form onSubmit={handleSubmit}>
                <Box mb={3}>
                    <TextField
                        fullWidth
                        label="Título"
                        variant="outlined"
                        name="titulo"
                        value={formData.titulo}
                        onChange={handleChange}
                        required
                    />
                </Box>

                <Box mb={3}>
                    <TextField
                        fullWidth
                        label="Subtítulo"
                        variant="outlined"
                        name="subtitulo"
                        value={formData.subtitulo}
                        onChange={handleChange}
                    />
                </Box>

                <Box mb={3}>
                    <MediaUploadField
                        label="Imagem do artigo"
                        name="imagem"
                        value={formData.imagem}
                        onChange={setFieldValue}
                        folder="artigos"
                        accept="image/*"
                        onError={handleUploadError}
                        onSuccess={handleUploadSuccess}
                    />
                </Box>

                <Box mb={3}>
                    <MediaUploadField
                        label="PDF do artigo"
                        name="pdfLink"
                        value={formData.pdfLink}
                        onChange={setFieldValue}
                        folder="artigos"
                        accept=".pdf,application/pdf"
                        onError={handleUploadError}
                        onSuccess={handleUploadSuccess}
                    />
                </Box>

                <Box mb={5}>
                    <Typography variant="body1" gutterBottom>
                        Conteúdo do Artigo:
                    </Typography>
                    <ReactQuill
                        value={formData.conteudo}
                        onChange={handleConteudoChange}
                        theme="snow"
                        modules={modules}
                        style={{ height: '300px' }}
                    />
                </Box>

                <Button fullWidth variant="contained" color="primary" type="submit">
                    Atualizar Artigo
                </Button>
            </form>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
                <Alert onClose={() => setOpenSnackbar(false)} severity={alertMessage.type}>
                    {alertMessage.text}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default EditarArtigo;
